import { connect } from 'react-redux';
import PieceInfo from './PieceInfo';
import { getPieceDetails } from '../../store/actions/pieceInfo';
import { getMap } from '../../store/actions/infoMap';

const mapStateToProps = ({
  userReducer,
  pieceInfoReducer
}) => ({
  userReducer,
  pieceInfoReducer
});
const mapDispatchToProps = {
  getPieceDetails,
  getMap
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PieceInfo);
